import MUIModal from '@mui/material/Modal';

import Box from '~/common/mui/Layout/Box';

type ModalProps = React.ComponentProps<typeof MUIModal> & {
  size?: 'md' | 'lg';
  containerSx?: React.ComponentProps<typeof Box>['sx'];
};

const Modal = ({
  children,
  size = 'md',
  open,
  containerSx,
  ...props
}: Readonly<ModalProps>) => {
  const { className, ...restProps } = props;
  const mergedClassName = ['mui-modal-root', className]
    .filter(Boolean)
    .join(' ');
  return (
    <MUIModal open={open} {...restProps}>
      <Box
        className={mergedClassName}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          maxWidth: size === 'md' ? '34rem' : '100%',
          boxShadow: 24,
          overflow: 'hidden',
          borderRadius: 6,
          ...containerSx,
        }}
      >
        {children}
      </Box>
    </MUIModal>
  );
};

export default Modal;
